//资源库首页稿件数  音频数 视频数

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Tabs, Modal} from 'antd';
import BaseComponent from "../../../../../base/BaseComponent";
import Statistics from '../compontent/Statistics';
import pic from '../img/picNum.png';
import video from '../img/videoNum.png';
import audio from '../img/audioNum.png';
import file from '../img/fileNum.png';
import story from '../img/storuNum.png'
const { TabPane } = Tabs;
export default class TableList  extends BaseComponent {
    static defaultProps = {
    };
    static propTypes = {
    };

    constructor(props) {
        super(props);
        this.state = {
            tabList:[{show:true, name:'全部资源',id:"1"},{show:false, name:'单位资源',id:"2"}],
            config:[{
                name:'稿件',
                src:story,
                key:"story",
                docCount:0
            },
                {
                    name:'图片',
                    src:pic,
                    key:"picture",
                    docCount:0
                },
                {
                    name:'视频',
                    src:video,
                    key:'video',
                    docCount:0
                },
                {
                    name:'音频',
                    src:audio,
                    key:'audio',
                    docCount:0
                },

                {
                    name:'其他',
                    src:file,
                    key:'other_file',
                    docCount:0
                }],
            current:'1',
        }
    }

    componentWillMount() {
    }
    componentDidMount() {
        this.getData()
    }

    render() {

        return(
            <div style={{display:'flex',width:"100%",
                    height:'184px',
                    background:"#FFFFFF",
                    boxShadow: "0px 2px 20px 10px rgba(0,80,179,0.08)",
                    borderRadius: "10px"}}>
                <div >
                    <div id={'tabList'}  style={{width:'166px',textAlign: "center",}}>
                        <Tabs tabPosition={'left'} tabBarStyle={{height:'184px',fontWeight: 700}} onChange={(data)=>{
                            this.onChange(data)
                        }}>
                            {this.state.tabList&&this.state.tabList.length&&this.state.tabList.map((item,index)=>{
                                return(
                                    <TabPane tab={item.name}   key={item.id} ></TabPane>
                                )
                            })}
                        </Tabs>
                        <style>{`#tabList .ant-tabs-tab{height:92px} 
                             #tabList .ant-tabs .ant-tabs-left-bar .ant-tabs-ink-bar{width:4px}
                             #tabList .ant-tabs-nav .ant-tabs-tab-active{background:#F5F8FC;font-weight: 700}
                             #tabList .ant-tabs .ant-tabs-left-bar .ant-tabs-tab{margin:0;padding:0;width:166px;text-align: center;line-height:92px}
                        `}</style>
                        {this.state.current==="1"? <style>{` #tabList .ant-tabs-nav .ant-tabs-tab-active{border-top-left-radius: 10px}  `}</style>:<style>{`
                             #tabList .ant-tabs-nav .ant-tabs-tab-active{border-bottom-left-radius: 10px}
                        `}</style>}

                    </div>
                </div>
                <div style={{padding:'32px 80px',width:'93%'}}>
                    {this.renderDataList()}
                </div>
            </div>



        )
    }

    onChange(data) {
        let {config} = this.state;
        config.forEach((item,index)=>{
            item.docCount = 0
        })
        this.setState({current:data,config:config},()=>{
            this.getData()
        })
    }
    renderDataList() {
        return (
            <div style={{display:'flex',justifyContent: 'space-between'}}>
                {this.state.config && this.state.config.length && this.state.config.map((item, index) => {
                    return <Statistics name={item.name} num={item.docCount} src={item.src} key={item.key}></Statistics>
                })}
            </div>

        )
    }
    //获取数据
    getData(){
        let param= {
            "fieldJson": {
                "aggType": "terms",
                "field": "_index"
            },

            "indexNameList": [
                "picture",
                "video",
                "audio",
                "other_file",
                "story"
            ]
        };
        if(this.state.current=== '2'){
            param.queryJson={
                "type": "term",
                "field": "authClassify.dept",
                "value": window.currentUser.deptIds[0],
                "boost": 1.0
            }
        }
        let {config} =this.state;
        this.request({
            url: "/search-server/search/getResourceCount",
            method: "POST",
            body: param,
            loading:true,
            contentType: 'json',
            callBack: (res) => {
             if(res&&res.length){
                 config.forEach((item,index)=>{
                    res.forEach((i,ids)=>{
                        if(item.key === i.key) {
                            item.docCount = i.docCount;
                        }
                    })
                 })
             }

              this.setState({})
            },

        });
    }

}
